<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<el-form :inline="true" :model="formInline" ref="searchForm">
					<el-form-item label="IMEI" prop="imei">
						<el-input v-model="formInline.imei" placeholder="请输入IMEI" clearable style="width:180px"></el-input>
					</el-form-item>
					<el-form-item label="类型" prop="type">
						<el-select v-model="formInline.type" placeholder="全部" clearable style="width:120px">
							<el-option label="上报" :value="1"></el-option>
							<el-option label="下发" :value="2"></el-option>
							<el-option label="其它" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="关键词" prop="keyword">
						<el-input v-model="formInline.keyword" placeholder="搜索日志内容" clearable style="width:200px"></el-input>
					</el-form-item>
					<el-form-item label="时间" prop="timeRange">
						<el-date-picker
							v-model="formInline.timeRange"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							value-format="YYYY-MM-DD HH:mm:ss"
							style="width:360px"
						></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search">{{ $t('device.inquire') }}</el-button>
						<el-button @click="reset">{{ $t('device.reset') }}</el-button>
					</el-form-item>
				</el-form>
			</template>

			<el-table :data="list" border stripe style="width:100%">
				<el-table-column label="IMEI" prop="imei" width="160"></el-table-column>
				<el-table-column label="类型" prop="type" width="80">
					<template #default="scope">
						<el-tag :type="typeTag(scope.row.type)" size="small">{{ typeName(scope.row.type) }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="内容" min-width="300">
					<template #default="scope">
						<span class="log-content">
							<span>{{ scope.row.content }}</span>
							<el-button type="primary" size="small" @click="viewLog(scope.row)">查看</el-button>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="时间" prop="create_at" width="180"></el-table-column>
			</el-table>

			<el-dialog title="日志详情" v-model="dialogVisible" width="600px" center>
				<el-input type="textarea" :rows="15" v-model="logContent" readonly></el-input>
			</el-dialog>

			<el-pagination
				:page-size="formInline.size"
				:page-sizes="[20, 50, 100, 200]"
				:total="total"
				:current-page="formInline.page"
				@current-change="handlePageChange"
				@size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper"
				style="margin-top:12px"
			></el-pagination>
		</el-card>
	</div>
</template>

<script>
import deviceLog from '../../model/deviceLog'

export default {
	name: 'DeviceLog',
	data() {
		return {
			formInline: {
				imei: '',
				type: '',
				keyword: '',
				timeRange: [],
				page: 1,
				size: 20,
			},
			list: [],
			total: 0,
			dialogVisible: false,
			logContent: '',
		}
	},
	mounted() {
		this.fetchList()
	},
	methods: {
		async fetchList() {
			const [start_time, end_time] = this.formInline.timeRange || []
			const ret = await deviceLog.list({
				imei: this.formInline.imei,
				type: this.formInline.type || 0,
				keyword: this.formInline.keyword,
				start_time: start_time || '',
				end_time: end_time || '',
				page: this.formInline.page,
				size: this.formInline.size,
			})
			if (ret.code === 200) {
				this.list = ret.data.list
				this.total = ret.data.count
			}
		},
		search() {
			this.formInline.page = 1
			this.fetchList()
		},
		reset() {
			this.$refs.searchForm.resetFields()
			this.formInline.timeRange = []
			this.formInline.page = 1
			this.fetchList()
		},
		handlePageChange(page) {
			this.formInline.page = page
			this.fetchList()
		},
		handleSizeChange(size) {
			this.formInline.size = size
			this.formInline.page = 1
			this.fetchList()
		},
		viewLog(row) {
			this.logContent = row.content
			this.dialogVisible = true
		},
		typeName(type) {
			return { 1: '上报', 2: '下发', 3: '其它' }[type] || '-'
		},
		typeTag(type) {
			return { 1: 'success', 2: 'primary', 3: 'info' }[type] || ''
		},
	},
}
</script>
<style scoped>
.log-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.log-content > span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
.log-content .el-button {
  flex-shrink: 0;
}
</style>
